<template>
  <component :is="layout"></component>
</template>

<script>
import LoginLayout from '@/layouts/login.vue'
import PrincipalLayout from '@/layouts/default.vue'
import {mapState} from 'vuex'

export default {
  // name: "Home",
  components: {
    LoginLayout,
    PrincipalLayout,
  },
  computed: mapState(['layout'])
  // data () {
  //   return {
  //     layout: 'principal-layout'
  //   }
  // },
};
</script>

<style>
</style>
